import { createReducer, on } from '@ngrx/store';
import * as SubscriptionActions from './subscription.actions';

export interface SubscriptionState {
  ai_tokens: number;
  credits: number;
  current_balance: number;
  last_allocation_date: string | null;
  next_allocation_date: string | null;
  subscription_amount: number | null;
  user: any;
  on_trial: boolean;
  subscribed: boolean;
  loading: boolean;
  error: any;
}

export const initialState: SubscriptionState = {
  ai_tokens: 0,
  credits: 0,
  current_balance: 0,
  last_allocation_date: null,
  next_allocation_date: null,
  subscription_amount: null,
  user: null,
  on_trial: false,
  subscribed: false,
  loading: false,
  error: null
};

export const subscriptionReducer = createReducer(
  initialState,
  on(SubscriptionActions.storeSubscriptionData, (state, { ai_tokens, credits, on_trial, subscribed }) => ({
    ...state,
    ai_tokens, credits, on_trial, subscribed
  })),
  on(SubscriptionActions.retrieveSubscriptionData, state => ({
    ...state
  })),
  on(SubscriptionActions.loadCredits, state => {
    return {...state, loading: true, error: null};
  }),
  on(SubscriptionActions.loadCreditsSuccess, (state, action) => ({
    ...state,
    current_balance: action.current_balance,
    credits: action.credits, // Synced with current_balance for backward compatibility
    last_allocation_date: action.last_allocation_date,
    next_allocation_date: action.next_allocation_date,
    subscription_amount: action.subscription_amount,
    ai_tokens: action.ai_tokens ?? state.ai_tokens,
    user: action.user ?? state.user,
    loading: false
  })),
  on(SubscriptionActions.loadCreditsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(SubscriptionActions.clearSubscriptionData, state => ({
    ...state,
    credits: null,
    aiTokens: null,
    user: null,
    loading: false,
    error: null
  }))
);
